"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../../Icon")),
    _navModal = require("../../styles/navModal"),
    _Text = _interopRequireDefault(require("../../../Text"));

function ModalHeader(a) {
  var b = a.title,
      c = a.subtitle;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_navModal.HEADER, "modal__header")
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_navModal.ICON_WRAPPER, "modal__icon-wrapper")
  }, _react["default"].createElement(_Icon["default"], {
    name: "template",
    color: "white",
    size: 15
  })), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_navModal.HEADER_TEXT, "modal__header__text")
  }, _react["default"].createElement(_Text["default"], {
    heading4: !0,
    noMargin: !0
  }, b), _react["default"].createElement(_Text["default"], {
    noMargin: !0
  }, c)));
}

var _default = (0, _react.memo)(ModalHeader);

exports["default"] = _default;